import { useMemo } from 'react';
import { useBreakpoint } from '@landr/maestro';

const usePlaceholderButton = ({
    isPlaceholderAllowed,
    isActivated,
}: {
    isPlaceholderAllowed: boolean;
    isActivated: boolean;
}): boolean => {
    const isMobile = useBreakpoint('md');

    const isPlaceholder = useMemo(
        () => isPlaceholderAllowed && !isActivated && !isMobile,
        [isPlaceholderAllowed, isActivated, isMobile],
    );

    return isPlaceholder;
};

export default usePlaceholderButton;
